import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./TbSetARType/Main";
import Form from "./TbSetARType/Form";

// Utils
import { getData, getAlert, getDataWithComp } from "../../../utils/SamuiUtils";
import { InitialDatatype } from "../../../model/InitialData/InitialDataDebtor";
import Navbar from "../../components/Modal/Navbar";

const Debtor = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataARtype, setDataARtype] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(InitialDatatype());

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime(); // เรียกใช้งาน fetchRealtime เพื่อโหลดข้อมูลเมื่อ component โหลดครั้งแรก
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getData(
        "Tb_Set_ARType",
        "1=1 AND Comp_Id =" + localStorage.getItem("company")
      );
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    setMode("U");
    setFormData({
      ARType_Id: item.ARType_Id,
      ARType_Name: item.ARType_Name,
      ARType_Status: item.ARType_Status,
    });
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <div className="wrapper">
        <Navbar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลประเภทลูกหนี้"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลประเภทลูกหนี้"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Debtor;
